import React from 'react';
import {
    Container, Row, Col
} from 'reactstrap';
//import MenuNew from '../MenuNew';
//import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
import {Link} from 'react-router';
import '../../assets/css/icon_report.css';
import '../../assets/css/page_success.css';




class Page extends React.Component {

    render() {
        return (
            <div>
                {/**  <MenuNew />
                <NavbarDrop />
                */}
                <Container id="wallet_slip">
                    <div >
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1 style={{ fontSize: 55}}>Parabéns!</h1>                            
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>

                </Container>

                <Container style={{ marginTop: -40 }} >
                    <Row style={{ marginRight: 0 }}>                        
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="12" lg="12" xl="12">
                            <p className="text_footer">Falta só mais um passo importante</p>
                            <div className="line_footer_gradient">{""}</div>
                        </Col>
                        <Col style={{ marginTop: 50, margiLeft: 30, textAlign: 'center', color: '#757575', fontSize: 16}} xs="12" sm="12" md="12" lg="12" xl="12">
                            <p><b>Chegou email para você. Vai lá, confira seus dados e clique <br/>no botão "confirmar adesão".</b></p>                            
                            <p>Não esqueça de seguir nossas redes sociais:</p>                  
                        </Col>
                        <Col sm="4"/>
                        <Col sm="4">
                            <Row>
                                <Link className="logo_success"  href="https://institucional.planodentalcenter.com.br/">&nbsp;</Link>
                            </Row>
                    
                        </Col>
                        <Col sm="4"/>
                    </Row>
                </Container>
                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Success/Page.js
 **/